import i18n from '@/plugins/i18n';

/**
 * Returns true if valid email or string with error message
 * @return {boolean|string}
 */
export const checkEmail = (val: string) => {
  // eslint-disable-next-line no-control-regex
  const regExp = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
  return regExp.test(val) ? true : i18n.t('validators.invalidEmail');
};

/**
 * Allowed values, e.g.
 * +49 123 4567489
 * 0123 456789
 * (0123) 456789
 * 0123 - 456789
 * 0123/456789
 *
 * @return {boolean|string}
 */
export const checkPhoneNumber = (val: string) => {
  const regExp = /^([+](\d{1,3})\s?)?((\(\d{3,5}\)|\d{3,5})(\s)?)\s?[-/]?\s?\d{3,8}$/;
  return regExp.test(val) ? true : i18n.t('validators.invalidPhoneNumber');
};

/**
 * Allowed values 5 digits
 *
 * @return {boolean|string}
 */
export const checkPostalCodeDE = (val: string) => {
  const regExp = /^[0-9]{5}$/;
  return regExp.test(val) ? true : i18n.t('validators.invalidPostalCode');
};
